import React from 'react';
import I18n from 'i18n-js';
import classNames from 'classnames';

import { RCIcon, RCTooltip } from '../';
import { CloseIcon } from '../../icons/react';

interface IProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>
  'aria-label'?: string;
  tooltipText?: string;
  inverted?: boolean;
}

export function RCCloseButton({
  onClick,
  'aria-label': ariaLabel,
  inverted = false,
  tooltipText = undefined,
}: IProps) {
  function handleClick(event) {
    // This is to prevent the hide function on the feed listing
    // card from opening the listing card in a new window
    event.preventDefault();
    event.stopPropagation();
    onClick(event);
  }

  const classes = classNames(
    'rc-close-button',
    { 'rc-close-button--inverted': inverted },
  );

  // Defining this inline is necessary so that refs can be forwarded to the component
  // this is used in RCTooltip
  const button = (
    <button
      type="button"
      onClick={handleClick}
      aria-label={ariaLabel || I18n.t('cadence.RCCloseButton.defaultLabel')}
      className={classes}
    >
      <RCIcon svgComponent={CloseIcon} />
    </button>
  );

  if (!tooltipText) {
    return button;
  }

  return (
    <RCTooltip text={tooltipText} type="plain">
      {button}
    </RCTooltip>
  );
}
